import Api from "../Api";

const basePath = '/vehicle';

export default {

  getVehicleProperties: (vin) => Api.get(`${basePath}/${vin}/mileage`)
}
